/** Permit follow-up date reminder (must match backend permitFollowUpEmailTriggers.cjs). */

export const PERMIT_FOLLOW_UP_EMAIL_TRIGGER_DEFINITIONS = [
  {
    id: "permit_follow_up",
    label: "Permit follow-up date (Permitting phase only)",
    group: "Permits",
    assignmentRecipients: true,
  },
];
